import React from 'react'
import Header from '_components/header/index.jsx'
import { useHistory } from 'react-router-dom'
import ListView from '_components/list-view/index.jsx'

const SegmentCofig = () => {
  const history = useHistory()

  return (
    <div>
      <Header
        title="Segments Configurations"
        actions={[
          {
            children: 'Create Segment Config',
            onClick: () => {
              history.push('/segment-configs/new')
            },
          },
        ]}
      />
      <ListView
        columns={[
          {
            name: 'Name',
            key: 'name',
            link: `/segment-configs/:_id`,
            sortable: true,
          },
          {
            name: 'Version',
            key: 'version',
          },
          {
            name: 'Created By',
            key: 'created_by.email',
          },
        ]}
        entities="destination-configuration"
        fields={['name', 'version', 'created_by']}
        filters={[]}
        searchable={true}
        sort_dir={1}
        sort_key={'name'}
      />
    </div>
  )
}

export default SegmentCofig
